module.exports = __webpack_public_path__ + "img/share-icon.72b947ff.svg";